import {
    ApiHandlerDiscreteParameter,
    createHandlerChainRunner,
    HasOnSuccess,
    HasOnError,
} from "@insite/client-framework/HandlerCreator";
import { post } from "@insite/client-framework/Services/ApiService";

export interface SubmitDynamicEmailApiParameter {
    emailTo: string;
    subject: string;
    templateName: string;
    model: any;
}

type SubmitAddressRequestParameter = {
    emailRecipients: string;
    address: any;
    onSuccess: any;
    onComplete?: () => void;
} & HasOnError;

function submitDynamicEmail(param: SubmitDynamicEmailApiParameter) {
    return post("/api/v1/email/dynamic", param);
}

type HandlerType = ApiHandlerDiscreteParameter<SubmitAddressRequestParameter, SubmitDynamicEmailApiParameter>;

export const PopulateApiParameter: HandlerType = props => {
    const a = props.parameter.address;

    props.apiParameter = {
        emailTo: props.parameter.emailRecipients,
        subject: "New Shipping Address Request",
        templateName: "AddressRequest",
        model: {
            firstName: a.firstName ?? "",
            lastName: a.lastName ?? "",
            attention: a.attention ?? "",
            companyName: a.companyName ?? "",
            address1: a.address1 ?? "",
            address2: a.address2 ?? "",
            address3: a.address3 ?? "",
            address4: a.address4 ?? "",
            city: a.city ?? "",
            state: a.state?.name ?? "",
            postalCode: a.postalCode ?? "",
            country: a.country?.name ?? "",
            phone: a.phone ?? "",
            email: a.email ?? "",
            fax: a.fax ?? "",
        },
    };
};

export const SendEmail: HandlerType = async props => {
    try {
        await submitDynamicEmail(props.apiParameter);
        props.parameter.onSuccess?.();
    } catch (error) {
        props.parameter.onError?.(error);
        throw error;
    }
};

export const chain = [PopulateApiParameter, SendEmail];

const submitAddressRequest = createHandlerChainRunner(chain, "SubmitAddressRequest");
export default submitAddressRequest;
